webpackJsonp([60],{

/***/ 1184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var customMethods = {
	list: { method: 'GET', url: 'housemaid-list' },
	housekeepingRooms: { method: 'GET', url: 'housekeeping-rooms' }
};

function housemaid(vm) {
	return vm.$resource('housemaid{/id}', {}, customMethods);
}

/* harmony default export */ __webpack_exports__["a"] = (housemaid);

/***/ }),

/***/ 1349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_housemaid__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_UserSelectorList__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_UserSelectorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_shared_UserSelectorList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_RoomNumberList__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_RoomNumberList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_shared_RoomNumberList__);





var changePage = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(value) {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.page = value;
						this.loadData(null, null, value);
						this.supervisors = [];
						this.rooms = [];

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changePage(_x) {
		return _ref.apply(this, arguments);
	};
}();

var changeRoomsPage = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(value) {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.roomsPage = value;
						this.selectHousemaid(this.model.selectedHousemaid, value, null, true);

					case 2:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function changeRoomsPage(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(filterGroups, sortGroup, page) {
		var parameters, response;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						parameters = {};

						if (filterGroups) {
							parameters.filter_groups = filterGroups;
						}
						if (sortGroup) {
							parameters.sort = sortGroup;
						}
						if (page) {
							parameters.page = page;
						}
						_context3.next = 6;
						return this.resource.list(parameters);

					case 6:
						response = _context3.sent;

						this.totalPages = response.data.last_page;
						this.items = this.loadSubsidiaries();
						this.rows = response.data.data.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, row);
							if (row.com_ms_state_emp_id > 1 && row.com_ms_state_emp_id < 6 || row.com_ms_state_emp_id === 7) {
								newRow.com_ms_state_emp_id = 2;
							} else if (row.com_ms_state_emp_id === 6) {
								newRow.com_ms_state_emp_id = 3;
							} else {
								newRow.com_ms_state_emp_id = row.com_ms_state_emp_id;
							}
							newRow.classActive = false;
							return newRow;
						});

					case 10:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData(_x3, _x4, _x5) {
		return _ref4.apply(this, arguments);
	};
}();

var selectHousemaid = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(housemaid, roomPage, filterGroups, keepRoomsSelected) {
		var _this3 = this;

		var parameters, response;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						if (!housemaid) {
							_context4.next = 16;
							break;
						}

						this.housemaidProfileHref = { name: 'housemaids-profile', params: { id: housemaid.id } };
						this.model.selectedHousemaid = housemaid;
						this.model.selectedHousemaidId = housemaid.id;
						this.rows = this.rows.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, row);
							if (row.id === housemaid.id) {
								newRow.classActive = true;
							} else {
								newRow.classActive = false;
							}
							return newRow;
						});
						parameters = {
							housemaid_id: housemaid.id,
							limit: 30,
							date_clear: this.model.filterDate
						};

						if (roomPage) {
							parameters.page = roomPage;
						}
						if (filterGroups) {
							parameters.filter_groups = filterGroups;
						} else {
							this.model.buildingId = 0;
							this.floors = [];
							this.model.floorId = 0;
							this.model.roomTypeId = 0;
							if (!keepRoomsSelected) {
								this.model.rooms = [];
							}
						}
						_context4.next = 10;
						return this.resource.housekeepingRooms(parameters);

					case 10:
						response = _context4.sent;

						this.totalRoomsPages = response.data.rooms.last_page;
						if (this.model.filterDate < currentDate.today) {
							this.rooms = response.data.rooms.data.map(function (room) {
								var newRoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, room);
								newRoom.code_room = room.number;
								newRoom.isAssigned = true;
								return newRoom;
							});
						} else {
							this.rooms = response.data.rooms.data.map(function (room) {
								var newRoom = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, room);
								newRoom.code_room = room.number;
								if (!room.com_employee_id) {
									newRoom.isSelected = false;
								} else if (room.com_employee_id === housemaid.id) {
									newRoom.isSelected = true;
								} else {
									newRoom.isAssigned = true;
								}
								if (keepRoomsSelected) {
									_this3.model.rooms.forEach(function (modelRoom) {
										if (room.id === modelRoom.id) {
											newRoom.isSelected = true;
										}
									});
								}
								return newRoom;
							}, this);
						}
						this.supervisors = response.data.supervisor;
						_context4.next = 18;
						break;

					case 16:
						this.model.filterDate = currentDate.today;
						this.showNotification('Los filtros solo se pueden usar después de elegir una mucama para asignar');

					case 18:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function selectHousemaid(_x6, _x7, _x8, _x9) {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var date = new Date();
var helperMethods = __WEBPACK_IMPORTED_MODULE_6__shared_helper__["a" /* default */].methods;

var currentDate = {
	day: date.getDate(),
	month: date.getMonth() < 9 ? '0' + date.getMonth() : date.getMonth() + 1,
	today: date.toISOString().substr(0, 10),
	value: date,
	year: date.getFullYear()
};

function created() {
	this.resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__resource_housemaid__["a" /* default */])(this);
	this.loadBuildings();
	this.loadRoomTypes();
	this.loadData();
}

function addRoomSelected(room, index) {
	if (room.isSelected) {
		this.model.rooms.push(room);
	} else {
		this.model.rooms.splice(index, 1);
	}
}

function changeIcon(result) {
	this.onChange = result;
}

function columnSortableEvent(_ref3) {
	var id = _ref3.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	var sortGroupAsc = [{
		key: newColumn[0].code,
		direction: newColumn[0].isSortable.up ? 'ASC' : 'DSC'
	}];
	this.loadData(null, sortGroupAsc);
}

function filterRooms() {
	var _this = this;

	this.roomsPage = 1;
	setTimeout(function () {
		_this.selectHousemaid(_this.model.selectedHousemaid, _this.roomsPage, _this.filtersRooms, true);
	}, 300);
}

function loadFloors(id) {
	var _this2 = this;

	this.buildings.forEach(function (building) {
		if (building.id === id) {
			_this2.floors = Array(building.floors);
		}
	});
	for (var i = 0; i < this.floors.length; i += 1) {
		this.floors[i] = i + 1;
	}
	this.model.floorId = 0;
	this.roomsPage = 1;
	setTimeout(function () {
		_this2.selectHousemaid(_this2.model.selectedHousemaid, _this2.roomsPage, _this2.filtersRooms, true);
	}, 300);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function roomsPagesVisible() {
	return this.totalRoomsPages < 5 ? this.totalRoomsPages : 5;
}

function searchByColumn(search) {
	var filterGroup = [{
		or: true,
		filters: [{
			key: 'name',
			value: search,
			operator: 'ct'
		}, {
			key: 'lastname',
			value: search,
			operator: 'ct'
		}]
	}];
	this.loadData(filterGroup);
}

function sendDataToAssign() {
	this.model.roomTypes = this.roomTypes;
	helperMethods.saveHousemaidAssign(this.model);
	this.$router.push(this.housemaidAssignHref);
}

function supervisorSelected(user) {
	this.model.currentSupervisor = user;
}

function filtersRooms() {
	var paramsUrl = [];
	var buildingFilter = {
		filters: [{
			key: 'hot_building_id',
			value: this.model.buildingId,
			operator: 'eq'
		}]
	};
	var floorFilter = {
		filters: [{
			key: 'hot_floor_id',
			value: this.model.floorId,
			operator: 'eq'
		}]
	};
	var roomtypeFilter = {
		filters: [{
			key: 'hot_ms_roomtype_id',
			value: this.model.roomTypeId,
			operator: 'eq'
		}]
	};
	if (this.model.buildingId > 0) {
		paramsUrl.push(buildingFilter);
	}
	if (this.model.floorId > 0) {
		paramsUrl.push(floorFilter);
	}
	if (this.model.roomTypeId > 0) {
		paramsUrl.push(roomtypeFilter);
	}
	return paramsUrl;
}

function dataIncomplete() {
	var _this4 = this;

	var sendData = false;
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.model).forEach(function (key) {
		if (!_this4.model[key] && _this4.model[key] !== 0 || _this4.model[key].length === 0) {
			sendData = true;
		}
	});
	return sendData;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_8__components_shared_ButtonCreate___default.a,
		RoomNumberList: __WEBPACK_IMPORTED_MODULE_10__components_shared_RoomNumberList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_4_table_run___default.a,
		UserSelectorList: __WEBPACK_IMPORTED_MODULE_9__components_shared_UserSelectorList___default.a
	},
	computed: {
		dataIncomplete: dataIncomplete,
		filtersRooms: filtersRooms,
		pagesVisible: pagesVisible,
		roomsPagesVisible: roomsPagesVisible
	},
	created: created,
	data: function data() {
		return {
			cleanTypes: [{ id: 1, name: 'Normal' }, { id: 2, name: 'Profunda' }],
			columns: [{ id: 1, name: 'Nombres', code: 'name', isSortable: { down: true, up: false } }],
			createHousemaidHref: { name: 'users-new' },
			filterValue: 1,
			floors: [],
			helperMethods: null,
			housemaidAssignHref: { name: 'housemaids-assign' },
			housemaidProfileHref: {},
			loading: false,
			menu: false,
			model: {
				filterDate: currentDate.today,
				floorId: 0,
				currentSupervisor: null,
				roomTypeId: 0,
				selectedHousemaid: null,
				selectedHousemaidId: null,
				buildingId: 0,
				rooms: []
			},
			onChange: false,
			page: 1,
			resource: null,
			rooms: null,
			roomsPage: 1,
			rows: [],
			supervisors: [],
			totalPages: 5,
			totalRoomsPages: null
		};
	},

	methods: {
		addRoomSelected: addRoomSelected,
		changeIcon: changeIcon,
		changePage: changePage,
		changeRoomsPage: changeRoomsPage,
		columnSortableEvent: columnSortableEvent,
		filterRooms: filterRooms,
		loadData: loadData,
		loadFloors: loadFloors,
		searchByColumn: searchByColumn,
		selectHousemaid: selectHousemaid,
		sendDataToAssign: sendDataToAssign,
		supervisorSelected: supervisorSelected
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	name: 'housemaids-list'
});

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".options-column[data-v-6a74eea1]{display:none}.options-column.options-column-housemaids[data-v-6a74eea1]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:distribute;justify-content:space-around}.options-column.options-column-housemaids span[data-v-6a74eea1]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.btn-to-profile[data-v-6a74eea1]{color:#545e72;display:block;font-family:San Francisco Display Semi Bold;font-size:11px}.btn-to-profile i[data-v-6a74eea1]{font-size:15px;vertical-align:top;width:8px}.medium[data-v-6a74eea1]{color:#353c4c;font-family:San Francisco Display Medium}", "", {"version":3,"sources":["/opt/build/repo/src/housekeeping/housemaids/List.vue"],"names":[],"mappings":"AACA,iCACE,YAAc,CACf,AACD,2DACI,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,yBAA0B,AACtB,4BAA8B,CACrC,AACD,gEACM,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CAC1B,AACD,iCACE,cAAe,AACf,cAAe,AACf,4CAA+C,AAC/C,cAAgB,CACjB,AACD,mCACI,eAAgB,AAChB,mBAAoB,AACpB,SAAW,CACd,AACD,yBACE,cAAe,AACf,wCAA4C,CAC7C","file":"List.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.options-column[data-v-6a74eea1] {\n  display: none;\n}\n.options-column.options-column-housemaids[data-v-6a74eea1] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n}\n.options-column.options-column-housemaids span[data-v-6a74eea1] {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n}\n.btn-to-profile[data-v-6a74eea1] {\n  color: #545e72;\n  display: block;\n  font-family: \"San Francisco Display Semi Bold\";\n  font-size: 11px;\n}\n.btn-to-profile i[data-v-6a74eea1] {\n    font-size: 15px;\n    vertical-align: top;\n    width: 8px;\n}\n.medium[data-v-6a74eea1] {\n  color: #353c4c;\n  font-family: \"San Francisco Display Medium\";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("76bb7f2c", content, true);

/***/ }),

/***/ 1662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "body-border-right": "",
      "body-border-right-full": "",
      "pr-3": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table table-custom-options",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-options": true,
      "include-export-to-excel": false,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchByColumn
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', {
          class: {
            'active': props.row.classActive
          }
        }, [_c('button', {
          staticClass: "button-transparent text-xs-left",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.selectHousemaid(props.row, _vm.roomsPage = 1)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(props.row.name) + " " + _vm._s(props.row.lastname) + "\n\t\t\t\t\t")]), _vm._v(" "), (props.row.classActive) ? _c('router-link', {
          staticClass: "btn-to-profile",
          attrs: {
            "to": _vm.housemaidProfileHref
          }
        }, [_vm._v("\n\t\t\t\t\t\tVer perfil "), _c('v-icon', [_vm._v("keyboard_arrow_right")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right pr-2 options-column options-column-housemaids",
          class: {
            'active': props.row.classActive
          }
        }, [_c('span', {
          class: ("circle-state state-" + (props.row.com_ms_state_emp_id))
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.room_assigned) + " hab.")])])]
      }
    }])
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.totalPages,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": _vm.changePage
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "pl-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": "",
      "body-border-bottom": "",
      "pb-2": ""
    }
  }, 'v-container', ( _obj = {}, _obj['grid-list-lg'] = true, _obj ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.model.selectedHousemaidId,
      "hide-details": "",
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadFloors
    },
    model: {
      value: (_vm.model.buildingId),
      callback: function($$v) {
        _vm.model.buildingId = $$v
      },
      expression: "model.buildingId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.floors,
      "disabled": _vm.floors.length === 0,
      "hide-details": "",
      "label": "Piso",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterRooms
    },
    model: {
      value: (_vm.model.floorId),
      callback: function($$v) {
        _vm.model.floorId = $$v
      },
      expression: "model.floorId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "pt-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.roomTypes,
      "item-text": "name",
      "item-value": "id",
      "disabled": !_vm.model.selectedHousemaidId,
      "hide-details": "",
      "label": "Tipo de habitación",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterRooms
    },
    model: {
      value: (_vm.model.roomTypeId),
      callback: function($$v) {
        _vm.model.roomTypeId = $$v
      },
      expression: "model.roomTypeId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "pt-2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Mucama',
      "href": _vm.createHousemaidHref
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.onChange ? 'arrow_drop_up' : 'arrow_drop_down',
      "append-icon-cb": function () { return (_vm.onChange = !_vm.model.filterDate); },
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.model.filterDate),
      callback: function($$v) {
        _vm.model.filterDate = $$v
      },
      expression: "model.filterDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.filterRooms
    },
    model: {
      value: (_vm.model.filterDate),
      callback: function($$v) {
        _vm.model.filterDate = $$v
      },
      expression: "model.filterDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": "",
      "body-border-bottom": "",
      "pb-2": "",
      "pt-3": ""
    }
  }, 'v-container', ( _obj$1 = {}, _obj$1['grid-list-lg'] = true, _obj$1 ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "medium pl-2"
  }, [_vm._v("Seleccione el supervisor:")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('user-selector-list', {
    staticClass: "pl-2",
    attrs: {
      "users": _vm.supervisors
    },
    on: {
      "on-change-selected": _vm.supervisorSelected
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": "",
      "body-border-bottom": "",
      "pb-2": "",
      "pt-3": ""
    }
  }, 'v-container', ( _obj$2 = {}, _obj$2['grid-list-lg'] = true, _obj$2 ), false), [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    staticClass: "medium pl-2"
  }, [_vm._v("Seleccione la habitación:")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-2": ""
    }
  }, _vm._l((_vm.rooms), function(room, indexRoom) {
    return _c('room-number-list', {
      key: room.id,
      attrs: {
        "tag": 'label',
        "index": indexRoom,
        "labelFor": ("rooms-" + (room.id)),
        "room": room
      },
      on: {
        "on-room-selected": _vm.addRoomSelected
      }
    })
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "mt-3": ""
    }
  }, [(_vm.rooms && _vm.rooms.length > 0) ? _c('v-pagination', {
    attrs: {
      "length": _vm.totalRoomsPages,
      "total-visible": _vm.roomsPagesVisible
    },
    on: {
      "input": _vm.changeRoomsPage
    },
    model: {
      value: (_vm.roomsPage),
      callback: function($$v) {
        _vm.roomsPage = $$v
      },
      expression: "roomsPage"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', _vm._b({
    attrs: {
      "fluid": "",
      "pb-2": "",
      "pt-3": "",
      "text-xs-right": ""
    }
  }, 'v-container', ( _obj$3 = {}, _obj$3['grid-list-lg'] = true, _obj$3 ), false), [(_vm.rooms && _vm.rooms.length > 0) ? _c('v-btn', {
    staticClass: "btn-assign-tasks",
    attrs: {
      "disabled": _vm.dataIncomplete
    },
    on: {
      "click": _vm.sendDataToAssign
    }
  }, [_vm._v("\n\t\t\t\t\tAsignar\n\t\t\t\t")]) : _vm._e()], 1)], 1)], 1)], 1)
  var _obj;
  var _obj$1;
  var _obj$2;
  var _obj$3;
},staticRenderFns: []}

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1501)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1349),
  /* template */
  __webpack_require__(1662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a74eea1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(953), __esModule: true };

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(955);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(18);
var fails = __webpack_require__(90);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(147);
var $keys = __webpack_require__(141);

__webpack_require__(954)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ })

});


// WEBPACK FOOTER //
// static/js/60.0fd96bc4acc6cebc4c48.js